/* istanbul ignore file */
const layoutContainerData = {
    "loading": {
        "roster": false
    }
};

if (typeof window['testData'] === 'undefined') window['testData'] = {};
window['testData']['layoutContainer'] = layoutContainerData;

export { layoutContainerData };
